module.exports = __webpack_public_path__ + "static/pic1-2eae68c8e61fdaa9cc7c2592d4c2b67c.svg";